export default __webpack_public_path__ + "static/media/Group 6411@3x.f924817b.png";